/**
 * 按首字母排序对象数组（大写在前，小写在后）
 * @param {Array} items - 对象数组
 * @param {string} key - 用于排序的对象属性名
 * @returns {Array} 排序后的数组
 */
export function sortLabelsByFirstLetter(items, key = 'label') {
  return [...items].sort((a, b) => {
    const aValue = a[key] || '';
    const bValue = b[key] || '';
    
    // 获取首字母的小写形式进行比较
    const aFirstChar = aValue.charAt(0).toLowerCase();
    const bFirstChar = bValue.charAt(0).toLowerCase();
    
    if (aFirstChar !== bFirstChar) {
      // 不同字母按字母顺序排序
      return aFirstChar.localeCompare(bFirstChar);
    } else {
      // 首字母相同，比较整个单词
      const aLower = aValue.toLowerCase();
      const bLower = bValue.toLowerCase();
      
      if (aLower === bLower) {
        // 整个单词只是大小写有差异，大写在前
        if (aValue === aValue.toUpperCase() && bValue !== bValue.toUpperCase()) return -1;
        if (aValue !== aValue.toUpperCase() && bValue === bValue.toUpperCase()) return 1;
        // 如果都是大写或都是小写，保持原顺序
        return 0;
      } else {
        // 单词不同，按字母顺序排序
        return aLower.localeCompare(bLower);
      }
    }
  });
}
